type ExchangePointsRule = Record<number, number>;

/**
 * 選択されたタイヤ本数からポイントを算出して表示する.
 *
 * @returns {void}
 */
const calculateTireExchangePreview = (): void => {
    const root = document.querySelector<HTMLElement>(".js-spec-tire-exchange");
    if (!root) return;

    const exchangePoints = JSON.parse(
        root.dataset.exchangePoints ?? "{}"
    ) as ExchangePointsRule;

    const pointsHeld = Number(root.dataset.pointsHeld ?? 0);

    const usedPointsEl = document.querySelector<HTMLElement>(".js-used-points");
    const remainingPointsEl = document.querySelector<HTMLElement>(
        ".js-remaining-points"
    );

    if (!usedPointsEl || !remainingPointsEl) return;

    const calculate = (): void => {
        const quantityInputs = root.querySelectorAll<HTMLInputElement>(
            ".js-spec-tire-quantity"
        );

        let totalQuantity = 0;

        quantityInputs.forEach((input) => {
            const value = Number(input.value);

            if (!Number.isNaN(value)) {
                totalQuantity += value;
            }
        });

        if (!(totalQuantity in exchangePoints)) {
            render(null, null);
            return;
        }
        // ルール内
        const usedPoints = exchangePoints[totalQuantity];
        const remainingPoints = pointsHeld - usedPoints;

        render(usedPoints, remainingPoints);
    };

    const render = (
        usedPoints: number | null,
        remainingPoints: number | null
    ): void => {
        if (usedPoints === null || remainingPoints === null) {
            usedPointsEl.textContent = "-";
            remainingPointsEl.textContent = "-";
            // remainingPointsEl.classList.add("error");
            return;
        }

        usedPointsEl.textContent = String(usedPoints);

        if (remainingPoints >= 0) {
            remainingPointsEl.textContent = String(remainingPoints);
            // remainingPointsEl.classList.remove("error");
        } else {
            remainingPointsEl.textContent = "—";
            // remainingPointsEl.classList.add("error");
        }
    };

    // input イベントで再計算
    root.addEventListener("input", (event: Event) => {
        const target = event.target as HTMLInputElement | null;

        if (
            target &&
            target.name.startsWith("spec_tires") &&
            target.name.endsWith("[quantity]")
        ) {
            calculate();
        }
    });

    // 初期表示
    calculate();
};

export default calculateTireExchangePreview;
